<template>
    <div class="result">
        <!-- 充值结果 -->
        <div class="result-pay-img" v-show="result.orderStatus == 1">
            <img src="@/images/sucess.png" alt="" srcset="">
                <div class="result-pay-text">充值成功</div>
            </div>
              <div class="result-pay-img" v-show="result.orderStatus == 0">
            <img src="@/images/fail.png" alt="" srcset="">
                <div class="result-pay-text">充值失败</div>
            </div>
        <!-- 充值信息  -->
        <div class="result-pay-info">
            <div>网吧：{{result.siteName}} </div>
            <div>订单编号：{{result.orderNumber}} </div>
            <div>充值金额：￥{{result.price}} </div>                        
        </div>
           <!-- 返回首页 -->
       <div class="return-home" v-show="result.orderStatus == 1" @click="handleClickGoHome">返回首页</div>
       <!-- 支付失败 -->
         <div class="fail-btn"  v-show="result.orderStatus == 2">
             <span @click="handleClickGoHome">返回首页</span>
             <span @click="handleClickAnew">重新支付</span>
        </div>
    </div>
 
</template>
<script>
export default {
    data() {
         return {
              result:''
         }
    },
    mounted() {
          this.result = JSON.parse(this.$route.query.data)
    },
    methods: {
         handleClickGoHome() {
             this.$router.push({
                  path:'/'
             })
         },
         handleClickAnew() {
                this.$router.push({
                  path:'/productpay'
             })
         }
    }
}
</script>
<style lang="scss" scoped>
        .result {
            overflow: hidden;
        }
    .result-pay-img {
        width: 100px;
        height: 100px;
        margin: 45px auto;
        text-align: center;

        img {
            width: 71px;
            height: 71px;
        }
        .result-pay-text {
            font-size: 20px;
            color: #333333;
            font-weight: bold;
        }
    }
    // 充值列表
    .result-pay-info {
        width: 349px;
        height: 114px;
        background-color: #EEEEEE;
        text-align: left;
        font-size: 14px;
        color: #666666;
        padding: 20px 14px;
        box-sizing: border-box;
        margin: 0 auto;
        div {
            margin-top: 15px;
            &:first-child {
                margin-top: 0
            }
        }
    
    }
    // 立即支付
     .return-home {
        width: 350px;
        height: 44px;
        background: -webkit-linear-gradient(left, #05AEFC, #008CFF);
        margin: 0 auto;
        border-radius: 22px;
        font-size: 16px;
        color: $white-color;
        line-height: 44px;
        margin:0 auto;
        margin-top: 228px;
     }
    //  支付失败 
    .fail-btn {
        width: 350px;
        margin: 0 auto;
        span {
            display:inline-block;
            width: 150px;
            height: 44px;
            border:1px solid #008CFF;
            text-align: center;
            line-height: 44px;
            border-radius: 22px;
            font-size: 16px;
            font-weight: bold;
            color: #008CFF;
            margin:0px 10px;
            margin-top: 228px;
            &:hover {
                 background: -webkit-linear-gradient(left, #05AEFC, #008CFF);
                 color: #FFFFFF;
            }
       
        }
    }
</style>